import type { Item } from '@/api/items/items.types';
import { ITEM_GROUP_ORDER } from '@/constants/item-group-order';
import { smartNameCompare } from '@/utils/smart-name-compare';

/**
 * Catalog default order: items bucketed by `ITEM_GROUP_ORDER`, then sorted
 * within each bucket with `smartNameCompare`. Shared between the external
 * catalog page (`useFilteredItems`) and the email builder's SAP item picker
 * so both surfaces present the catalog in the same order.
 */
export function compareByItemGroupThenName(a: Item, b: Item): number {
  const aIdx = a.itemGroup ? ITEM_GROUP_ORDER.indexOf(a.itemGroup) : -1;
  const bIdx = b.itemGroup ? ITEM_GROUP_ORDER.indexOf(b.itemGroup) : -1;
  const aOrder = aIdx === -1 ? ITEM_GROUP_ORDER.length : aIdx;
  const bOrder = bIdx === -1 ? ITEM_GROUP_ORDER.length : bIdx;
  if (aOrder !== bOrder) return aOrder - bOrder;
  return smartNameCompare(a.name, b.name);
}
